export enum ValidationIssueStatus {
  New = 'New',
  InReview = 'InReview',
  Resolved = 'Resolved',
}

export enum ValidationIssueType {
  Unknown = 'Unknown',
  ValueMismatch = 'ValueMismatch',
  MissingField = 'MissingField'
}

export interface ValidationIssue {
  id: number;
  leftValue: string;
  rightValue: string;
  description: string;
  comment?: string;
  status: ValidationIssueStatus;
  type: ValidationIssueType;
  loanDocumentIds: number[];
  rule: ValidationRule;
}

export enum RuleType {
  DocToData = 'DocToData',
  DocToDoc = 'DocToDoc'
}

export enum ComparisonOperator {
  Equals = 'Equals',
  CloseTo = 'CloseTo'
}

export interface ValidationRule {
  id: number;
  type: RuleType;
  operator: ComparisonOperator;
  operands: ValidationRuleOperand[];
}

export enum OperandPosition {
  Left = 'Left',
  Right = 'Right'
}

export enum OperandType {
  DocumentField = 'DocumentField',
  LoanProperty = 'LoanProperty',
  Expression = 'Expression'
}

export interface ValidationRuleOperand {
  name: string;
  type: OperandType;
  position: OperandPosition;
  documentType?: string;
}